import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { UUID, Workspace, WorkspaceUpdatePayload } from "@/lib/types";

interface Vars {
  workspaceId: UUID;
  payload: WorkspaceUpdatePayload;
}

export function useUpdateWorkspace() {
  const qc = useQueryClient();
  return useMutation<Workspace, Error, Vars>({
    mutationFn: ({ workspaceId, payload }) => api.updateWorkspace(workspaceId, payload),
    onSuccess: (ws) => {
      qc.setQueryData<Workspace[]>(queryKeys.workspaces, (prev) =>
        prev ? prev.map((w) => (w.id === ws.id ? { ...w, ...ws } : w)) : prev,
      );
      void qc.invalidateQueries({ queryKey: queryKeys.workspaces });
    },
  });
}
